/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  dispute: ModelRegistry['dispute'];
}

interface UiProtectionDisputePanelDeadlineSignature {
  Element: HTMLElement;

  Args: IArgs;
}

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export default class UiProtectionDisputePanelDeadlineComponent extends Component<UiProtectionDisputePanelDeadlineSignature> {
  @cached
  get respondBy(): Date | undefined {
    return this.args.dispute.respondBy;
  }

  @cached
  get daysLeft(): number | undefined {
    const { respondBy } = this;

    if (!respondBy) {
      return undefined;
    }

    return Math.max(
      0,
      Math.ceil((respondBy.getTime() - Date.now()) / MS_PER_DAY),
    );
  }

  @cached
  get isUrgent(): boolean {
    const { daysLeft } = this;

    return daysLeft !== undefined && daysLeft <= 3;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Deadline': typeof UiProtectionDisputePanelDeadlineComponent;
    'ui/protection/dispute-panel/deadline': typeof UiProtectionDisputePanelDeadlineComponent;
  }
}
